import React from 'react'
import styled from 'styled-components'
import { MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import Container from '~shared/Container'

const Inner = styled.div`
    padding: 0;

    @media ${MqTablet} {
        padding: 0 96px;
    }

    @media ${MqDesktop} {
        padding: 0 208px;
    }
`

const Column = styled.div`
    border: 1px solid #e8e6e6;
    border-width: 1px 0;
    padding: 64px 0;

    @media ${MqTablet} {
        padding: 80px 0;
    }

    @media ${MqDesktop} {
        padding: 96px 0;
    }
`

const Content = styled.div`
    .techStack,
    .readMore {
        flex-basis: 50%;
    }

    .readMore {
        margin-top: 32px; /* Current line-height. */
    }

    @media ${MqTablet} {
        display: flex;

        .techStack {
            padding-right: 24px;
            text-align: right;
        }

        .readMore {
            margin-top: 0;
            padding-left: 24px;
        }
    }

    @media ${MqDesktop} {
        .techStack {
            padding-right: 28px;
        }

        .readMore {
            padding-left: 28px;
        }
    }
`

const CaseStudyReadMore = ({ techStack, readMore, ...props }) => (
    <div {...props}>
        <Container>
            <Inner>
                <Column>
                    <Content>
                        <div className="techStack" $appearIntersection>
                            {techStack}
                        </div>
                        <div className="readMore" $appearIntersection>
                            {readMore}
                        </div>
                    </Content>
                </Column>
            </Inner>
        </Container>
    </div>
)

export default CaseStudyReadMore
